var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"responsive-img",attrs:{"src":_vm.imgLetterJacketPlaceholder,"alt":"Letter Jacket Placeholder Image"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f30f6fc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/letter-jackets/catalog-details/components/LetterJacketPlaceholderImage.vue
// module id = 1312
// module chunks = 0